// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bLoading{display:flex;align-items:center;height:100%;justify-content:center;text-align:center}", ""]);
// Exports
module.exports = exports;
